class RecipientUsername extends HTMLSelectElement {
  // Not implemented yet
  constructor() {
    super();
    this.template = document.createElement('template');
  }
}

customElements.define('recipient-username', RecipientUsername, {extends: 'select'})

export class LocationHours extends HTMLElement {
  constructor(site_chat_hours) {
    super();
    this.site_chat_hours = site_chat_hours;
    this.addHours = this.addHours.bind(this);
    this.removeHours = this.removeHours.bind(this);
    this.deletedHours;
  }
  connectedCallback() {
    this.location_hours_container = this.closest("#location-hours-container");
    this.innerHTML = 
      `
      <div class="row" style="margin-bottom:5px; position:relative;">
        <div class="col-md-2 no-gutters">
          <select class="form-control" id="location-hours-day">
            <option value="127">Any Day</option>
            <option value="62">Weekdays</option>
            <option value="65">Weekends</option>
            <option value="2">Monday</option>
            <option value="4">Tuesday</option>
            <option value="8">Wednesday</option>
            <option value="16">Thursday</option>
            <option value="32">Friday</option>
            <option value="64">Saturday</option>
            <option value="1">Sunday</option>
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-control" id="location-hours-length">
            <option value="0">All Day</option>
            <option value="1">Between</option>
          </select>
        </div>
        <div class="col-md-5 hidden" id="location-hours-select">
          <select name="site_start_hour" class="form-control" style="width:auto; display: inline;">
            <option checked="" value="00">12 AM</option>
            <option value="01">1 AM</option>
            <option value="02">2 AM</option>
            <option value="03">3 AM</option>
            <option value="04">4 AM</option>
            <option value="05">5 AM</option>
            <option value="06">6 AM</option>
            <option value="07">7 AM</option>
            <option value="08">8 AM</option>
            <option value="09">9 AM</option>
            <option value="10">10 AM</option>
            <option value="11">11 AM</option>
            <option value="12">12 PM</option>
            <option value="13">1 PM</option>
            <option value="14">2 PM</option>
            <option value="15">3 PM</option>
            <option value="16">4 PM</option>
            <option value="17">5 PM</option>
            <option value="18">6 PM</option>
            <option value="19">7 PM</option>
            <option value="20">8 PM</option>
            <option value="21">9 PM</option>
            <option value="22">10 PM</option>
            <option value="23">11 PM</option>
          </select>
          :
          <select name="site_start_minute" class="form-control" style="width:auto;display: inline;">
            <option>00</option>
            <option>05</option>
            <option>10</option>
            <option>15</option>
            <option>20</option>
            <option>25</option>
            <option>30</option>
            <option>35</option>
            <option>40</option>
            <option>45</option>
            <option>50</option>
            <option>55</option>
          </select>
          <span>to</span>
          <select name="site_end_hour" class="form-control" style="width:auto;display: inline;">
            <option checked="" value="00">12 AM</option>
            <option value="01">1 AM</option>
            <option value="02">2 AM</option>
            <option value="03">3 AM</option>
            <option value="04">4 AM</option>
            <option value="05">5 AM</option>
            <option value="06">6 AM</option>
            <option value="07">7 AM</option>
            <option value="08">8 AM</option>
            <option value="09">9 AM</option>
            <option value="10">10 AM</option>
            <option value="11">11 AM</option>
            <option value="12">12 PM</option>
            <option value="13">1 PM</option>
            <option value="14">2 PM</option>
            <option value="15">3 PM</option>
            <option value="16">4 PM</option>
            <option value="17">5 PM</option>
            <option value="18">6 PM</option>
            <option value="19">7 PM</option>
            <option value="20">8 PM</option>
            <option value="21">9 PM</option>
            <option value="22">10 PM</option>
            <option value="23">11 PM</option>
          </select>
          :
          <select name="site_end_minute" class="form-control" style="width:auto;display: inline;">
            <option>00</option>
            <option>05</option>
            <option>10</option>
            <option>15</option>
            <option>20</option>
            <option>25</option>
            <option>30</option>
            <option>35</option>
            <option>40</option>
            <option>45</option>
            <option>50</option>
            <option>55</option>
          </select>
        </div>
        <div class="col-md-2 pull-right no-gutters" style="line-height:30px;">
          <button class="btn btn-outline-danger remove_hours pull-right">Remove</button>
        </div>
      </div>
      `;

    // this.querySelector(".add_hours").addEventListener("click", this.addHours)
    this.querySelector(".remove_hours").addEventListener("click", this.removeHours.bind(this))
    if(this.site_chat_hours) {
      this.setHours();
    }
    this.querySelector('#location-hours-length').onchange = () => {
      this.toggleHours();
    }
  }

  getHoursObject() {
    let hours = {
      site_chat_hours_id: this.site_chat_hours ? this.site_chat_hours.site_chat_hours_id : null,
      day_map: this.querySelector('#location-hours-day').value,
      _deleted: this.deletedHours ? true : false
    };
    if(this.querySelector('#location-hours-length').value == '0') {
      hours.start_time = '0000';
      hours.end_time = '2400';
    } else {
      hours.start_time = `${this.querySelector('[name="site_start_hour"]').value}${this.querySelector('[name="site_start_minute"]').value}`;
      hours.end_time = `${this.querySelector('[name="site_end_hour"]').value}${this.querySelector('[name="site_end_minute"]').value}`;
    }
    return hours;
  }

  setHours() {
    this.querySelector('#location-hours-day').value = this.site_chat_hours.day_map;
    if(this.site_chat_hours.start_time == '0000' && this.site_chat_hours.end_time == '2400') {
      this.querySelector('#location-hours-length').value = 0;
      this.toggleHours();
    } else {
      this.querySelector('#location-hours-length').value = 1;
      this.querySelector('[name="site_start_hour"]').value = this.site_chat_hours.start_time.slice(0, 2);
      this.querySelector('[name="site_start_minute"]').value = this.site_chat_hours.start_time.slice(2);
      this.querySelector('[name="site_end_hour"]').value = this.site_chat_hours.end_time.slice(0, 2);
      this.querySelector('[name="site_end_minute"]').value = this.site_chat_hours.end_time.slice(2);
      this.toggleHours();
    }
  }

  toggleHours() {
    if(this.querySelector('#location-hours-length').value == 0) {
      this.querySelector('#location-hours-select').classList.add('hidden');
    } else {
      this.querySelector('#location-hours-select').classList.remove('hidden');
    }
  }

  addHours() {
    let Hours = new LocationHours();
    this.closest("#location-hours-container").appendChild(Hours);
  }

  removeHours() {
    if(this.site_chat_hours) {
      // Post data for existing hours being deleted
      document.querySelector('message-center-settings').addDeletedHours({site_chat_hours_id: this.site_chat_hours.site_chat_hours_id, _deleted: true})
    } else {
      this.deletedHours = {site_chat_hours_id: null, _deleted: false}
    }
    this.remove();
    document.querySelector('message-center-settings').buttonVisibility();
  }
}

customElements.define('location-hours', LocationHours)

export class LeadScoreForm extends HTMLElement {
  constructor(actions, type_data) {
    super();
    this.actions = actions;
    this.type_data = type_data;
  }
  connectedCallback() {
    // Add comma/space for display only
    this.innerHTML = 
    `
    <style>
      .dealsaver-field-container {
        margin-bottom:24px;
      }

      #dealsaver-container .location-site-attributes {
        margin-bottom:0px;
      }

      #dealsaver-container .well {
        padding:10px;
      }

      #dealsaver-container {
        margin-bottom:30px;
      }

      #leadscore-integrations-container .form-control {
        margin-bottom: 10px;
      }

      #leadscore-integrations-container {
        line-height: 36px !important;
        font-size: 18px;
      }

      leadscore-form .add_webhook {
        display: none;
      }

      leadscore-form call-processing-integration:last-child .add_webhook {
          display: inline-block;
      }

      leadscore-form call-processing-integration:nth-child(n+5) .add_webhook {
         display: none;
      }

      leadscore-form call-processing-integration:only-of-type .remove_webhook {
          display: none;
      }
    </style>
    <div class="row dealsaver-field-container well">
      <div class="col-sm-12 no-gutters location-settings-switch-div location-site-attributes">
        <h4>${this.type_data.text}</h4>
      </div>
      <div class="col-sm-12 no-gutters form-group">
        <label>Integrations</label>
        <div id="leadscore-integrations-container">
        </div>
      </div>
    </div>
    `;

    if(this.actions && this.actions.length > 0) {
      console.log("ACTION");
      console.log(this.actions)
      this.actions.forEach(action => this.addAction(action.action_id))
    } else {
      this.addAction();
    }
  }

  validate() {
    let isValid = [];
    let actions = []
    this.querySelectorAll("call-processing-integration").forEach(elem => {
      if(elem.getValue() != null && actions.includes(elem.getValue())) {
        isValid.push("duplicate_integrations");
      } else {
        actions.push(elem.getValue());
      }
    });
    return isValid;
  }

  getData() {
    let actions = Array.from(this.querySelectorAll("call-processing-integration")).filter((data) => data.getValue() != null).map((action) => action.getValue())
    return {
      call_type_id: this.type_data.call_type_id,
      actions: actions
    };
  }

  addAction(action_id = null) {
    let callProcessingIntegration = new CallProcessingIntegration(action_id, this.addAction.bind(this));
    this.querySelector("#leadscore-integrations-container").appendChild(callProcessingIntegration);
  }
}

customElements.define('leadscore-form', LeadScoreForm)

export class DealSaverForm extends HTMLElement {
  constructor(dealsaver, actions, type_data) {
    super();
    this.dealsaver = dealsaver;
    this.actions = actions
    this.type_data = type_data;
  }
  connectedCallback() {
    // Add comma/space for display only
    let recipients = this.dealsaver ? this.dealsaver.recipients.split(',').join(', ') : '';
    let enabled = this.dealsaver ? (this.dealsaver.enabled == 1 ? true : false) : false;
    this.innerHTML = 
    `
    <style>
      .dealsaver-field-container {
        margin-bottom:24px;
      }

      #dealsaver-container .location-site-attributes {
        margin-bottom:0px;
      }

      #dealsaver-container .well {
        padding:10px;
      }

      #dealsaver-container {
        margin-bottom:30px;
      }

      dealsaver-form .form-control {
        margin-bottom: 30px;
      }

      #dealsaver-integrations-container .form-control {
        margin-bottom: 10px;
      }

      #dealsaver-integrations-container {
        line-height: 36px !important;
        font-size: 18px;
      }

      dealsaver-form .add_webhook {
        display: none;
      }

      dealsaver-form call-processing-integration:last-child .add_webhook {
          display: inline-block;
      }

      dealsaver-form call-processing-integration:nth-child(n+5) .add_webhook {
         display: none;
      }

      dealsaver-form call-processing-integration:only-of-type .remove_webhook {
          display: none;
      }
    </style>
    <div class="row dealsaver-field-container well">
      <div class="col-sm-12 no-gutters location-settings-switch-div location-site-attributes">
        <h4>${this.type_data.text}</h4>
      </div>
      <div class="col-sm-12 no-gutters form-group">
        <label class="pull-left" style="padding-top: 6px; padding-right: 20px;">Email Alerts</label>
        <label class="switch pull-left">
          <input type="checkbox" class="form-control switch" id="dealsaver-notifications" ${enabled ? 'checked' : ''}>
          <span data-cy="dealsaver-notifications-switch"></span>
        </label>
        <textarea class="form-control dealsaver-recipients" placeholder="Please separate email addresses by using a comma">${recipients}</textarea>
        <label>Integrations</label>
        <div id="dealsaver-integrations-container">
        </div>
      </div>
    </div>
    `;
    if(this.actions && this.actions.length > 0) {
      this.actions.forEach(action => this.addAction(action.action_id))
    } else {
      this.addAction();
    }
  }

  validate() {
    let isValid = [];
    let new_emails = this.querySelector('.dealsaver-recipients').value.replace(/\s/g,'').split(',');
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })

    new_emails.forEach(address => {
      if(!Common.validateCommaSeperatedEmail(address) && this.querySelector('.dealsaver-recipients').value) {
        this.querySelector('.dealsaver-recipients').classList.add('error')
        isValid.push('email');
      }
    })

    if(this.querySelector('#dealsaver-notifications').checked && !this.querySelector('.dealsaver-recipients').value) {
      this.querySelector('.dealsaver-recipients').classList.add('error')
      isValid.push('empty');
    }

    let actions = []
    this.querySelectorAll("call-processing-integration").forEach(elem => {
      if(elem.getValue() != null && actions.includes(elem.getValue())) {
        isValid.push("duplicate_integrations");
      } else {
        actions.push(elem.getValue());
      }
    });

    return isValid;
  }

  getDealsavers() {
    let actions = Array.from(this.querySelectorAll("call-processing-integration")).filter((data) => data.getValue() != null).map((action) => action.getValue())
    let data = {
      location_dealsaver_id: this.dealsaver ? this.dealsaver.location_dealsaver_id : null,
      call_type_id: this.type_data.call_type_id,
      enabled: this.querySelector('#dealsaver-notifications').checked ? 1 : 0,
      recipients: this.querySelector('.dealsaver-recipients').value.replace(/\s/g,''),
      actions: actions
    };
    if(this.validate()) {
      return data;
    }
  }

  addAction(action_id = null) {
    let callProcessingIntegration = new CallProcessingIntegration(action_id, this.addAction.bind(this));
    this.querySelector("#dealsaver-integrations-container").appendChild(callProcessingIntegration);
  }
}

customElements.define('dealsaver-form', DealSaverForm)

class CallProcessingIntegration extends HTMLElement {
  constructor(action_id = null, addAction) {
    super();
    this.action_id = action_id
    this.addAction = addAction;
  }

  connectedCallback() {
    this.innerHTML = `
              <div class="row">
                <div class="col-md-6 no-gutters">
                  <select is=webhook-select class="form-control" data-selected=${this.action_id}></select>
                </div>
                <div class="col-md-2">
                  <a class="remove_webhook"><span class="fa fa-minus"></span></a>
                  <a class="add_webhook"><span class="fa fa-plus"></span></a>
                </div>
              </div>
                `

    this.querySelector(".add_webhook").addEventListener("click", this.addAction);
    this.querySelector(".remove_webhook").addEventListener("click", () => this.parentNode.removeChild(this));
  }

  getValue() {
    let value = this.querySelector("select").value;
    return value != "null" ? value : null;
  }
}

customElements.define("call-processing-integration", CallProcessingIntegration)